import { View } from 'react-native';
import type { ViewProps } from 'react-native';

import { useTheme } from '../theme/ThemeProvider';

export interface CardProps extends ViewProps {
  padding?: number;
}

export function Card({ padding, style, ...rest }: CardProps) {
  const theme = useTheme();
  return (
    <View
      style={[
        {
          backgroundColor: theme.colors.surface,
          borderColor: theme.colors.border,
          borderWidth: 1,
          borderRadius: theme.radius.md,
          padding: padding ?? theme.spacing(4),
        },
        style,
      ]}
      {...rest}
    />
  );
}
